module.exports = __webpack_public_path__ + "img/image47.dccc98b0.webp";